import { useState } from 'react';
import { Form, Input, Segment, Message } from 'semantic-ui-react';
import Center from '../../../components/Auth/Center';
import CenterWidth from '../../../components/Auth/CenterWidth';
import HeaderName from '../../../components/Auth/HeaderName';
import CenterMessage from '../../../components/CenterMessage';
import ButtonStretch from '../../../components/ButtonStretch';
import { api_url } from '../../../config';

function RequestPasswordReset() {
	const [ saving, setSaving ]            = useState(false);
	const [ error, setError ]              = useState(false);
	const [ sent_message, setSentMessage ] = useState(false);
	const [ email, setEmail ]              = useState();

	function handleInput(e) {
		setEmail(e.target.value);
	}

	function handleSubmit() {
		setSaving(true);
		setSentMessage(false);
		setError(false);

		if(!email) {
			setError(true);
		}

		fetch(`${api_url}/request_reset_password`, {
			method : `POST`,
			body   : JSON.stringify({ email }),
			headers : {
				'Content-Type' : `application/json`
			}
		}).then(response => response.json()).then(data => {
			setSentMessage(true);
			setSaving(false);
		});
	}

	return (
		<Center>
			<CenterWidth>
				<HeaderName />

				{sent_message &&
					<Message success>An email has been sent to reset your password</Message>
				}

				<Message info>Reset your password</Message>

				<Segment>
					<Form>
						<Form.Field>
							<label>Enter your email address and we'll send you a password reset link</label>
							<Input name="email" onChange={handleInput} />
						</Form.Field>

						<ButtonStretch loading={saving} positive onClick={handleSubmit}>Submit</ButtonStretch>
					</Form>
					{error &&
						<CenterMessage negative>
							<p>Invalid email</p>
						</CenterMessage>
					}
				</Segment>
			</CenterWidth>
		</Center>
	);
}

export default RequestPasswordReset;
